module.exports = __webpack_public_path__ + "img/Amadeus_Logo.20107991.png";